import 'whatwg-fetch'
import '@babel/polyfill'
import DefaultDefine from '@/define'
import Vue from 'vue'
import App from './App.vue'
import store from './store'
import moment from 'moment-timezone';
import ISO6391 from 'iso-639-1';
import VModal from 'vue-js-modal'
import i18n from './i18n'
import vuescroll from 'vuescroll';
import vSelect from 'vue-select';
import "@/scss/default.scss";
import VCalendar from 'v-calendar';
import InfiniteLoading from 'vue-infinite-loading';
import VTooltip from 'v-tooltip'
import {router} from './routes/index.js';
import 'vue-cal/dist/vuecal.css';
import VueCal from 'vue-cal';
import Vuelidate from 'vuelidate'
import VueFriendlyIframe from 'vue-friendly-iframe';
import Draggable from 'vuedraggable';
import firebase from 'firebase/app';
import * as FirebaseConf from './firebase-config';
import ECharts from 'vue-echarts'
import 'echarts';
import 'echarts/lib/chart/bar'
import 'echarts/lib/component/tooltip'
import VueEllipseProgress from 'vue-ellipse-progress';

import './scss/section.scss';
import './scss/patient.scss';

Vue.prototype.$fb = firebase;
Vue.prototype.$fbConf = FirebaseConf;
Vue.prototype.moment = moment;
Vue.prototype._TIME_ZONE = moment.tz.guess();
Vue.prototype.ISO6391 = ISO6391;

Vue.component('Draggable', Draggable);
Vue.component('v-chart', ECharts);
Vue.component('vue-cal', VueCal);
Vue.component('v-select', vSelect);

Vue.use(vuescroll, {
    ops: {
        bar: {
            onlyShowBarOnScroll: false,
            background: '#a3a3a3',
            opacity: 1,
            size: '8px'
        },
        scrollPanel: {
            scrollingY: false
        }
    },
});
Vue.component('vue-scroll', vuescroll);
Vue.use(VueFriendlyIframe);
Vue.use(Vuelidate);
Vue.use(VTooltip);
Vue.use(InfiniteLoading, {
    props: {
        distance: 10,
        spinner: 'circles'
    }
});
Vue.use(VCalendar);
Vue.use(VModal);
Vue.use(VueEllipseProgress);

Vue.config.productionTip = false;

router.onError((error)=> {
    try {
        if (error.toString().toLowerCase().includes("chunk"))
            window.location.href = window.location.origin;
    } catch (e) {

    }
})

new Vue({
    store,
    i18n,
    router,
    render: h => h(App),
}).$mount('#app');